export default __webpack_public_path__ + "media/components/AdEdit/images/instagram-heart-f612f2efbacb6c59b2f826ea49a26af0.png";